import { ArrowRight } from "lucide-react";
import { useLeadModal } from "../../context/LeadModalContext";
import { Reveal } from "../Reveal";

export function FinalCTA() {
  const { openLeadForm } = useLeadModal();

  return (
    <section data-testid="final-cta-section" className="relative overflow-hidden bg-forest-deep py-24 lg:py-32">
      <div className="bg-noise pointer-events-none absolute inset-0" />
      <div
        className="pointer-events-none absolute left-1/2 top-1/2 h-[480px] w-[720px] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-25"
        style={{ background: "radial-gradient(ellipse, rgba(212,175,55,0.45) 0%, transparent 65%)" }}
      />
      <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-gold">The Last Scroll</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-4xl font-extrabold leading-[1.08] tracking-tight text-bone sm:text-5xl lg:text-6xl">
            Stop guessing.{" "}
            <em className="font-editorial font-medium italic text-gold">Start moving forward.</em>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-emerald-100/65 sm:text-lg">
            One free call. One clear plan. The version of you that already made this decision is waiting.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <button
            data-testid="final-cta-btn"
            onClick={() => openLeadForm("final_cta")}
            className="group mt-10 inline-flex items-center gap-2.5 rounded-full bg-gold px-10 py-5 font-display text-lg font-bold text-forest-deep shadow-[0_0_50px_rgba(212,175,55,0.35)] transition-transform duration-200 hover:-translate-y-1 hover:shadow-[0_0_70px_rgba(212,175,55,0.5)]"
          >
            Book Your Free Strategy Call Today
            <ArrowRight className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" />
          </button>
        </Reveal>
        <Reveal delay={0.4}>
          <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-emerald-100/40">
            Free 30-minute call · No obligation · Reply within 24 hours
          </p>
        </Reveal>
      </div>
    </section>
  );
}
